<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' }" [template]="customLoadingTemplate"></ngx-loading>
<ng-template #customLoadingTemplate></ng-template>
<form>
	<div class="row mt-4">
		<div class="col-8">
			<app-planes-bloque [type]="'wizard'" [planes]="planes" [planSeleccionado]="planSeleccionado" [planUsuario]="planUsuarioPagado" (actualizarPlan)="updatePlan($event)"></app-planes-bloque>
		</div>
		<div class="col-4" *ngIf="!user.isPartner">
			<app-resumen-bloque *ngIf="planUsuarioPagado" [planSeleccionado]="planSeleccionado" [certificaciones]="certificaciones" [type]="'wizard'" [planUsuario]="planUsuarioPagado" (actualizarResumen)="notifyResumen($event)" [compraCertificado]="compraCertificado" [resumenBorrador]="resumenBorrador"></app-resumen-bloque>
		</div>
		<div class="col-4" *ngIf="user.isPartner">
			<div class="card border-width-3 border-radius-0 border-color-hover-dark" data-plugin-sticky data-plugin-options="{'minWidth': 991, 'containerSelector': '.row', 'padding': {'top': 85}}">
				<div class="card-body">
					<h4 class="font-weight-bold text-uppercase text-4 mb-3">RESUMEN</h4>
					<p>Los valores de los planes son los ofrecidos al público en general. Dependiendo de tu nivel de Partner, será el descuento que se aplicará al plan en la facturación.</p>
					<p>Recuerda que el cobro se realiza a mes vencido por el cálculo de los DTE adicionales, el último día hábil del mes, con fecha de vencimiento 5 días corridos desde su emisión.</p>
				</div>
			</div>
		</div>
	</div>
</form>
